import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { getWeholiteAttenuationRows, MAX_WEHOLITE_SECTIONS } from "../../../utils/stormBuildUpWeholiteAttenuation";
import { COLORS } from "../../../utils/constants";

type WeholiteAttenuationTableProps = Omit<StormBuildUpTableProps, 'rows' | 'onDeleteSection' | 'onConfigureSection'> & {
  sectionCount: number;
  supplierName?: string;
  sectionTitles?: Record<string, string>;
  onAddTank: () => void;
  onDeleteSection: (headerId: string) => void;
  onConfigureSection: (headerId: string) => void;
  weholiteConfigPct?: Record<string, number>;
};

export default function WeholiteAttenuationTable({ sectionCount, supplierName, sectionTitles, onAddTank, onDeleteSection, onConfigureSection, weholiteConfigPct, ...props }: WeholiteAttenuationTableProps) {
  return (
    <div>
      <StormBuildUpTable
        rows={getWeholiteAttenuationRows(sectionCount, weholiteConfigPct, supplierName, sectionTitles)}
        onDeleteSection={onDeleteSection}
        onConfigureSection={onConfigureSection}
        {...props}
      />
      <div style={{ marginTop: '16px' }}>
        <Button
          type="text"
          icon={<PlusOutlined style={{ color: COLORS.primary }} />}
          onClick={onAddTank}
          disabled={sectionCount >= MAX_WEHOLITE_SECTIONS}
          style={{ color: COLORS.primary, fontWeight: 500, padding: '4px 8px' }}
        >
          Add New Tank
        </Button>
      </div>
    </div>
  );
}
